import styled from 'styled-components';

export const ReservationContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px 48px;
`;
